// extracted by mini-css-extract-plugin
export default {"container":"SupplierSwitch_container__9cZ9Y","name":"SupplierSwitch_name__R7AEI"};